<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Record Certification Progress
							</div>
							<!-- Page Header -->
						
							<div class="page_main">
								<div class="training-cert-page">
						
									<div class="page-title">
										Selected Training Records
									</div>
						
									<div class="card-block">
										<el-table ref="recordTable" :data="trainingRecords" border>
											<el-table-column label="User" prop="username" min-width="120" sortable />
											<el-table-column label="Training Item" prop="item_name" min-width="180" sortable />
											<el-table-column label="Training Completion Date" prop="" min-width="180" sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.end_time) }}
												</template>
											</el-table-column>
											<el-table-column label="Purpose" prop="purpose" min-width="120" sortable>
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
												</template>
											</el-table-column>
											<el-table-column label="Certification Due Date" prop="deadline" min-width="190" sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.certification_end_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="method" label="Certification Method" min-width="150">
												<template slot-scope="scope">
													{{ scope.row.certification_method || '' }}
												</template>
											</el-table-column>
											<el-table-column label="Certification Evidence Files" min-width="240">
												<template slot-scope="scope">
													<ul class="file-list-inline">
														<li v-for="(file, index) in scope.row.image_list" :key="index" style="padding: 4px 0;">
															<a :href="file.url" target="_blank">{{ file.name }}</a>
														</li>
													</ul>
												</template>
											</el-table-column>
										</el-table>
									</div>
						
									<div class="btn_el">
										<div class="tips">
											Please enter a description of the certification method (for example: Test, Observation, or No Recertification Required).
										</div>
									</div>
						
									<div class="card-block form-block">
										<div class="form-label">
											Certification Method
										</div>
										<el-input type="textarea" :rows="3" v-model="form.method" placeholder="Please enter the certification method" />
									</div>
						
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">
												Certification Evidence Files
											</div>
										</div>
						
										<el-table ref="fileTable" :data="evidenceFiles" border>
											<el-table-column label="File Name" prop="name" min-width="500" />
											<el-table-column prop="id" label="Actions" width="100" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini" @click="handleRemove(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
						
										<div class="file-action-row">
											<el-upload
												class="upload-demo"
												action="/api/trainUploads"
												name="files"
												:data="uploadData"
												:headers="{ token: userToken }"
												:show-file-list="false"
												:before-upload="beforeAvatarUpload"
												:on-success="handleAvatarSuccess"
												:with-credentials="true"
												multiple
											>
												<el-button size="small" type="primary">
													Add Certification Evidence Files
												</el-button>
											</el-upload>
										</div>
									</div>
						
									<div class="footer-actions">
										<el-button type="primary" @click="handleSaveDraft">
											Save for Later
										</el-button>
										<el-button type="primary" @click="handleComplete">
											Mark Certification as Complete
										</el-button>
										<el-button @click="handleCancel">
											Cancel
										</el-button>
									</div>
						
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	trainRecordCertificationDetail,
	trainRecordCertification
} from '@/api/trainManage/configTrain/trainRecord/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from 'moment';
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			form: {
				method: "",
			},
			uploadData: {
				train_leixing: 2
			},
			trainingRecords: [],
			evidenceFiles: [],
			userToken: localStorage.getItem("userToken"),
			trainIds: null,
			infoData: null,
		};
	},
	created() {
		let that = this;
		that.trainIds = that.$route.query.ids;
	},
	mounted() {
		let that = this;
		//请求页面详情
		trainRecordCertificationDetail({ ids: that.trainIds }).then(res => {
			if(res.code == 200) {
				that.infoData = res.data;
				that.isLoading = false;
				that.trainingRecords = res.data.train_list;
				that.form.method = that.infoData.certification_method;
				if(that.infoData.certification_files_list.length > 0) {
					that.infoData.certification_files_list.forEach((value, index) => {
						that.evidenceFiles.push({ id: value.id, name: value.name });
					});
				}
			}
		});
	},
	methods: {
		//时间戳转换
		initTime(value) {
			if(value) {
				return moment(value * 1000).format('YYYY-MM-DD');
			}
		},
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.evidenceFiles.push({ id: res.data.id, name: res.data.name });
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10MB");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		//保存稍后
		handleSaveDraft() {
			let that = this;
			if(that.form.method && that.evidenceFiles.length > 0) {
				let ids = that.evidenceFiles.map(item => item.id).join(',');
				that.$toast.loading({ duration: 0, forbidClick: true });
				trainRecordCertification({
					ids: that.trainIds,
					certification_method: that.form.method,
					certification_files: ids
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.back();
						}, 800);
					}
				});
			}else {
				that.$message.warning("Please complete authentication information first.");
			}
		},
		//标记认证完成
		handleComplete() {
			let that = this;
			if(that.form.method && that.evidenceFiles.length > 0) {
				let ids = that.evidenceFiles.map(item => item.id).join(',');
				that.$toast.loading({ duration: 0, forbidClick: true });
				trainRecordCertification({
					ids: that.trainIds,
					certification_method: that.form.method,
					certification_files: ids
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$router.push({ path: "/TrainControl/assign-complete", query: { type: "certification", ids: that.trainIds } });
					}
				});
			}else {
				that.$message.warning("Please complete authentication information first.");
			}
		},
		//删除文件
		handleRemove(value) {
			let that = this;
			const index = that.evidenceFiles.findIndex(item => item.id === value.id);
			if(index !== -1) {
				that.evidenceFiles.splice(index, 1);
			}
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-cert-page {
  padding: 10px;
  background: #fff;
  min-height: 100%;
  box-sizing: border-box;
}

.page-title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 10px;
}

.card-block {
  margin-bottom: 12px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.search-input {
  width: 180px;
}

.form-block {
  margin-bottom: 14px;
}

.form-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 6px;
  font-weight: 600;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.file-action-row {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

.footer-actions {
  margin-top: 26px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.file-list-inline {
  margin: 0;
  padding-left: 0px;
}

.file-list-inline li {
  line-height: 20px;
}

/* 更接近截图的表格视觉 */
::v-deep .el-table th {
  padding: 10px 0;
}

::v-deep .el-table td {
  padding: 10px 0;
}

::v-deep .el-table .current-row > td {
  background-color: #eef3ff !important;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

